type QueryInnerValue = boolean | number | string;
type QueryValue = QueryInnerValue | QueryInnerValue[] | undefined;
type QueryObject = Record<string, QueryValue>;

const isDefinedQueryValue = (
  value: QueryValue,
): value is Exclude<QueryValue, undefined> => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === 'string') {
    return value.length > 0;
  }

  if (typeof value === 'boolean') {
    return true;
  }

  if (typeof value === 'undefined') {
    return false;
  }

  if (!isNaN(value)) {
    return true;
  }

  return false;
};

export const toQueryString = (queryObject: QueryObject) => {
  const url = new URL('https://example.com');

  Object.entries(queryObject).forEach(([key, value]) => {
    if (isDefinedQueryValue(value)) {
      if (Array.isArray(value)) {
        value.forEach(innerValue =>
          url.searchParams.append(key, String(innerValue)),
        );
      } else {
        url.searchParams.append(key, String(value));
      }
    }
  });

  return `?${url.searchParams.toString()}`;
};
